module.exports = __webpack_public_path__ + "img/world_of_acredo.ba5a4fa.jpg";